export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/v05140b63f03cca1ed077a83a361dc4dabd2667f0-runtime-main.5c0f6940.worker.js");
}
